var App = App || {};

App.QuizCards = (function ($) {
    'use strict';

    function Init() {
        const quizCards = $(".blog-list-card.blog-quiz-card");

        if (quizCards.length) {
            quizCards.each(function () {
                var quizCard = $(this)
                var answerBtns = quizCard.find(".quiz-answers button");

                answerBtns.on("click", function () {
                    quizCard.addClass("answered");
                    quizCard.find(".question-card").attr("aria-hidden", true);
                    quizCard.find(".answer-card").attr("aria-hidden", false);

                    if ($(this).data("cor") == "True") {
                        quizCard.addClass("correct");
                        quizCard.find(".correct-feedback").attr("aria-hidden", false);
                        quizCard.find(".incorrect-feedback").attr("aria-hidden", true);
                    }
                });
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.QuizCards.Init();
});